import { ChallengeTag } from "../../../../types/Challenge";
import CardFilter, { CardFilterItem } from "../card-filter";
import styles from "./index.module.scss";

export interface DynamicTagsFilterProps {
  values?: string[][];
  onChange?: (values: string[][]) => void;
  tags?: ChallengeTag[];
}
const DynamicTagsFilter = ({
  values = [],
  onChange,
  tags = [],
}: DynamicTagsFilterProps) => {
  const handleCardFilterChange = (curValues: string[], index: number) => {
    const newValues = [...values];
    newValues[index] = curValues;
    onChange?.(newValues);
  };

  return (
    <div className={styles.dynamicTagsFilter} style={{ marginTop: 12 }}>
      {tags.map((row, index) => {
        return (
          <CardFilter
            multiple
            key={row.id}
            title={row.name}
            justifyContent="start"
            items={(row.sub_tags || []).map(
              (tag) =>
                ({
                  label: tag.name,
                  value: String(tag.id),
                } as CardFilterItem)
            )}
            values={values[index] || []}
            style={{ boxShadow: "none" }}
            onChange={(currentCardValues) =>
              handleCardFilterChange(currentCardValues, index)
            }
          />
        );
      })}
    </div>
  );
};

export default DynamicTagsFilter;
